import { useRef } from "react";
import { Button } from "primereact/button";
import { Menu } from "primereact/menu";
import { useNavigate } from "react-router-dom";

const AppUserToolbar = ({ onManageOwnership, onTermsAction, termsAccepted, acceptTermsLoading }) => {
  const navigate = useNavigate();
  const menu = useRef(null);

  const items = [
    {
      label: "Manage Ownership",
      icon: "pi pi-crown",
      command: onManageOwnership,
    },
    {
      label: termsAccepted ? "Terms Audit Log" : "Accept Terms on Behalf",
      icon: termsAccepted ? "pi pi-history" : "pi pi-check-circle",
      disabled: acceptTermsLoading,
      command: onTermsAction,
    },
  ];

  return (
    <div className="flex justify-content-between mb-3">
      <Button
        label="Back to List"
        icon="pi pi-arrow-left"
        severity="secondary"
        onClick={() => navigate("/users")}
      />
      <Menu model={items} popup ref={menu} id="app_user_actions_menu" />
      <Button
        label="Manage"
        icon="pi pi-ellipsis-v"
        iconPos="right"
        onClick={(e) => menu.current?.toggle(e)}
        aria-controls="app_user_actions_menu"
        aria-haspopup
      />
    </div>
  );
};

export default AppUserToolbar;
